import { HttpHeaders } from '@angular/common/http';
import { ObjectMap } from '../../components/app-table/app-table-models';
import { CONFIG } from '../../models/config';

const AUTH_URL = `${CONFIG.authUrl}/auth/authorize`;
const REDIRECT_URL = `${CONFIG.webUrl}/logga-in`;
const VERIFIER_STORAGE_KEY = 'login-code-verifier';
const CHALLENGE_STORAGE_KEY = 'login-code-challenge';
const SILENT_REFRESH_TIMEMOUT = 2000;
const CLIENT_ID = 'svebar-portal';

interface AuthResponse {
  code: string;
  state: string;
  type: string;
  error: string;
}
export enum ResponseError {
  UNAUTHORIZED = 'error.saknar_behörighet',
  UNKNOWN = 'Okänt fel',
  OBJECT_UPDATED_BY_OTHER_USERS = '"$object" har uppdaterats av annan användare',
  NETWORK_ERROR = 'error.nätverk',
  RELOAD_FOR_LATEST_CHANGES = 'Vänligen ladda om sidan för att hämta senaste ändringar',
  LOCKED_ACCOUNT = 'error.anvandare_ej_registrerad',
  UNACTIVATED_ACCOUNT = 'Detta kontot är inte aktiverat\nVänligen kontakta en administratör för aktivering',
  AUTH_REFRESH_ERROR = 'Kunde ej förnya inloggningssession',
  CODEVERIFIER_ERROR = 'Ingen sparad codeverifier för inloggningssession',
  USER_SESSION_MISSING = 'Session för användaren saknas',
  UTREDNING_MISSING = 'Utredning hittades ej',
  BESTALLNING_MISSING = 'Beställningen hittades ej',
}

export function create(path: string, query: ObjectMap<string> = {}) {
  const url_query = new URLSearchParams(query).toString();
  return `${path}?${url_query}`;
}


export function silentAuthentication(): Promise<string> {
  return new Promise<string>((resolve, reject) => {
    const codeChallenge = sessionStorage.getItem(CHALLENGE_STORAGE_KEY);
    // @ts-ignorec
    const refreshUrl = create(AUTH_URL, createRefreshQuery(codeChallenge));
    const iframe = document.createElement('iframe');
    iframe.style.display = 'none';
    const state = '/';
    let responded = false;
    const closeIframe = () => {
      window.removeEventListener('message', receiveResponse, false);
      // @ts-ignore
      iframe.contentWindow.close();
      window.document.body.removeChild(iframe);
    };
    const receiveResponse = (event: MessageEvent<AuthResponse>) => {
      const response = event.data;
      if (response.type === 'authorization_response') {
        closeIframe();
        responded = true;
        const origin = event.origin;
        const expectedOrigin = location.origin;
        if (expectedOrigin !== origin) {
          console.error('Wrong origin', event);
          throw Error(`Origin ${origin} not matching with expected origin ${expectedOrigin}`);
        }
        if (response.error) throw response;
        if (response.state !== state) throw Error('State does not match.');
        resolve(response.code);
      }
    };
    window.addEventListener('message', receiveResponse);
    window.document.body.appendChild(iframe);
    iframe.setAttribute('src', refreshUrl);
    // Close iframe if no response within timeout
    setTimeout(() => {
      if (!responded) {
        closeIframe();
        reject(Error(ResponseError.AUTH_REFRESH_ERROR));
      }
    }, SILENT_REFRESH_TIMEMOUT);
  });
}
export function createRefreshQuery(codeChallenge: string) {
  return {
    redirect_uri: `${location.origin}${REDIRECT_URL}`,
    response_type: 'code',
    response_mode: 'web_message',
    prompt: 'none',
    code_challenge: codeChallenge,
    code_challenge_method: 'S256',
    state: '/',
  };
}

/** Exchanges OAuth auth code for auth token and returns the token */
export function getTokenFromAuthCode(authCode: string, id?: string) {
  const httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' }),
  };
  const codeVerifier = sessionStorage.getItem(VERIFIER_STORAGE_KEY);
  if (!codeVerifier) {
    console.error('No codeverifier saved in session');
    throw Error(ResponseError.CODEVERIFIER_ERROR);
  }
  const body = new URLSearchParams();
  body.set('grant_type', 'code');
  body.set('code', authCode);
  body.set('client_id', CLIENT_ID);
  body.set('code_verifier', codeVerifier);
  body.set('redirect_uri', `${location.origin}${REDIRECT_URL}`);
  body.set('theChosenOrgId', id ? `${id}` : '')
  return {body, httpOptions}
}

export function isWithinFiveMinutes(targetDateTimeInSeconds: number) {
  const now = new Date();
  const target = new Date(targetDateTimeInSeconds * 1000);

  const diffInMs = Math.abs(target.getTime() - now.getTime());
  const fiveMinutesInMs = 5 * 60 * 1000;

  return diffInMs <= fiveMinutesInMs;
}
